
import { Vue, Component } from "vue-property-decorator";

import { readFileAsJSON } from "../utils/read-file-as-json";
import { readFileAsBase64 } from "../utils/read-file-as-base64";
import {
  findInfoFile,
  isValidSongInfo,
  isInfoVersion1_5,
  isInfoVersion2_0,
  getSongCoverDataUrl,
  getSongName,
  getVersion
} from "../lib/beatmap-format-helper";
import { ISongInfo, ISongInfoV1_5, ISongInfoV2_0 } from "../model/common/index";
import transform from "../lib/transform1_5to2_0";
import JSZip from "jszip";
import { download } from "../utils/download";
import Song from "../lib/song";

import AppHeader from "./AppHeader.vue";
import SongChooser from "./SongChooser.vue";
import SongList from "./SongList.vue";
import SongDetailView from "./SongDetailView.vue";
import AppFooter from "./AppFooter.vue";

@Component({
  components: {
    AppHeader,
    SongChooser,
    SongList,
    SongDetailView,
    AppFooter
  },
  data() {
    return {
      files: null,
      songs: [],
      detailSong: null
    };
  }
})
export default class MainView extends Vue {
  files: File[] | null = null;
  songs: Song[] = [];
  detailSong: Song | null = null;

  constructor() {
    super();
    this.handleChange = this.handleChange.bind(this);
  }

  async handleChange(ev: Event) {
    let input = ev.target as HTMLInputElement;
    if (!input.files || !input.files.length) return;
    let files = (this.files = Array.from(input.files));
    files.map(file =>
      Song.createFromZip(file).then(song => this.songs.push(song))
    );
  }

  viewDetail(song: Song) {
    this.detailSong = song;
  }
}
